import React from "react";
import { Button } from "react-bootstrap";
import LandingPage from "../components/landingPage";
import Projects from "../components/projects";

function Home() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default Home;
